import { RPC_URLS, APP_CHAIN } from '@/client/confs/app';
import { createPublicClient, fallback, http } from 'viem';

export const publicClient = createPublicClient({
  chain: APP_CHAIN,
  transport: fallback(
    RPC_URLS.map(url => http(url, { retryCount: 2, retryDelay: 500 })),
    { rank: false }
  ),
  batch: {
    multicall: {
      batchSize: 1024 * 200,
      wait: 100,
    },
  },
  cacheTime: 10_000,
  pollingInterval: 30_000,
});
